// Utils
import makeSelectOptionsSelector from 'fc-utils/makeSelectOptionsSelector'

// Constants
import {
  PROP_LABEL,
} from 'fc-model-assets'

// Selectors
import fieldsWithNoJobs$ from './fieldsWithNoJobs'

// Exports
export default makeSelectOptionsSelector(PROP_LABEL)(fieldsWithNoJobs$)
